"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const vue_3 = require("vue");
const RolesModal_vue_1 = __importDefault(require("./RolesModal.vue"));
const ShiftModal_vue_1 = __importDefault(require("./ShiftModal.vue"));
exports.default = (0, vue_1.defineComponent)({
    __name: 'SpotWorkerModalWrapper',
    setup(__props) {
        const isRoleOpen = (0, vue_3.ref)(false);
        const isShiftOpen = (0, vue_3.ref)(false);
        const selectedRoleId = (0, vue_3.ref)(0);
        function openRoleModal() {
            isRoleOpen.value = true;
        }
        function closeRoleModal() {
            isRoleOpen.value = false;
            // Clear selection if closed without selecting
            if (!isShiftOpen.value) {
                selectedRoleId.value = 0;
            }
        }
        function handleRoleSelected(roleId) {
            selectedRoleId.value = roleId;
            isShiftOpen.value = true;
        }
        function closeShiftModal(isCreated) {
            isShiftOpen.value = false;
            // Clear selection after successful creation or cancellation
            if (isCreated) {
                selectedRoleId.value = 0;
                isRoleOpen.value = false;
            }
        }
        return (_ctx, _cache) => {
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)(vue_2.Fragment, null, [
                ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(vue_2.Teleport, { to: "#spot-slot-btn" }, [
                    (0, vue_2.createElementVNode)("button", {
                        onClick: openRoleModal,
                        class: "excel-link-btn excel btn delete-btn"
                    }, "単発スタッフ")
                ])),
                ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(vue_2.Teleport, { to: "body" }, [
                    (isRoleOpen.value)
                        ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(RolesModal_vue_1.default, {
                            key: 0,
                            onCloseModal: closeRoleModal,
                            onSelectedRoleId: handleRoleSelected
                        }))
                        : (0, vue_2.createCommentVNode)("v-if", true),
                    (isShiftOpen.value)
                        ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(ShiftModal_vue_1.default, {
                            key: 1,
                            "role-id": selectedRoleId.value,
                            "selected-shift-id": 0,
                            onCloseShiftModal: closeShiftModal
                        }, null, 8 /* PROPS */, ["role-id"]))
                        : (0, vue_2.createCommentVNode)("v-if", true)
                ]))
            ], 64 /* STABLE_FRAGMENT */));
        };
    }
});
